import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme, isDark } = useTheme();

  const getIcon = () => {
    switch (theme) {
      case 'light':
        return <Sun className="w-4 h-4" />;
      case 'dark':
        return <Moon className="w-4 h-4" />;
      case 'system':
        return <Monitor className="w-4 h-4" />;
      default:
        return <Sun className="w-4 h-4" />;
    }
  };

  const getLabel = () => {
    switch (theme) {
      case 'light':
        return 'Switch to dark mode';
      case 'dark':
        return 'Switch to system mode';
      case 'system':
        return 'Switch to light mode';
      default:
        return 'Toggle theme';
    }
  };

  return (
    <button
      onClick={toggleTheme}
      className={`
        relative p-2 rounded-lg transition-all duration-200 
        focus:outline-none focus:ring-2 focus:ring-offset-2
        ${isDark 
          ? 'text-gray-300 hover:text-white hover:bg-gray-700 focus:ring-green-400' 
          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:ring-green-500'
        }
      `}
      aria-label={getLabel()}
      title={getLabel()}
    >
      <div className="relative">
        {getIcon()}
        
        {/* Theme indicator dot */}
        <div 
          className={`
            absolute -top-1 -right-1 w-2 h-2 rounded-full transition-colors duration-200
            ${theme === 'system' 
              ? 'bg-blue-500' 
              : theme === 'dark' 
                ? 'bg-purple-500' 
                : 'bg-yellow-500'
            }
          `}
          aria-hidden="true"
        />
      </div>
    </button>
  );
};

export default ThemeToggle;
